const ROUTE_ROOT = '/'
const ROUTE_LOGIN = '/login'
const ROUTE_REGISTER = '/register'
const ROUTE_OVERVIEW = '/overview'
const ROUTE_ARTICLE = '/article'
const ROUTE_USER = '/user'

const routes = {
	ROUTE_ROOT,
	ROUTE_LOGIN,
	ROUTE_REGISTER,
	ROUTE_OVERVIEW,
	ROUTE_ARTICLE,
	ROUTE_USER
}

export default routes